// Meta Pixel gestito dal sistema di consenso esistente (lsh_cookie_consent).
// Nessun evento marketing prima del consenso; nessun secondo banner.
const STORAGE_KEY = "lsh_cookie_consent";

export const metaConsentGranted = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "granted";
  } catch {
    return false;
  }
};

// Allinea il consenso nativo del Pixel (grant/revoke) alla scelta cookie.
export const metaConsent = (granted) => {
  if (typeof window.fbq !== "function") return;
  window.fbq("consent", granted ? "grant" : "revoke");
};

// Invia un evento SOLO se il consenso marketing e' stato concesso e il Pixel e' caricato.
export const metaTrack = (event, params = {}, opts = {}) => {
  if (!metaConsentGranted()) return;
  if (typeof window.fbq !== "function") return;
  if (opts.eventID) window.fbq("track", event, params, { eventID: opts.eventID });
  else window.fbq("track", event, params);
};

export const META_FRIENDLY = {
  "RESTART-DATING-DIGITAL": "Restart Dating 45+ Digital",
  "RESTART-DATING-PREMIUM": "Restart Dating 45+ Premium",
};
